export default __webpack_public_path__ + "images/erickson-living.svg?aa4c595bcc7dab4fadea31f25fc61e9a";